<lib-ui-sidebar [logo]="logo" [navigation]="navigation">
  <ng-content select="[topbarActions]" ngProjectAs="[topbarActions]"></ng-content>
  <router-outlet />
</lib-ui-sidebar>
